<div class="row">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">Edit Question</h2>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="card card-cascade narrower">
      <div class="view gradient-card-header primary-gradient white-text">
        <h3 class='h3-responsive text-center text-truncate'>{{question.prompt || "Untitled"}}</h3>
      </div>
      <div class="card-body">
        <form>
          <div class="form-group">
            <label for="type">Type:</label>
            <input class="form-control" type="text" id="type" name="type" [value]="getQuestionType(question)" readonly />
          </div>
          <div class="form-group">
            <label for="prompt">Prompt:</label>
            <input class="form-control" type="text" id="prompt" name="prompt" [(ngModel)]="question.prompt" />
          </div>
          <!--<div class="form-group">
          <label for="displayOrder">Display Order:</label>
		  <input class="form-control" type="number" id="displayOrder" name="displayOrder" [(ngModel)]="ctrl.question.display_order" />
    </div>-->
        <div class="form-group" *ngIf="allowCustomLabels()" >
          <label for="prompt">Question Labels:</label>
          <dac-question-labels-edit [question]="question"></dac-question-labels-edit>
        </div>
          
        <div class="form-group">
            <input class="form-control" [checked]="question.skip_scoring" 
              type="checkbox" id="skipScoring" name="skipScoring" [(ngModel)]="question.skip_scoring" />
            <label for="skipScoring">Do not score:</label>
          </div>
          <div class="form-group">
            <input class="form-control" [checked]="question.is_reversed" 
              type="checkbox" id="isReversed" name="isReversed" [(ngModel)]="question.is_reversed" />
            <label for="isReversed">Is Reversed:</label>
          </div>
          <div class="form-group">
              <input class="form-control" (click)="toggleFlagQuestion(question)" [checked]="question.hasFlagCondition" type="checkbox"
              id="hasFlagCondition" name="hasFlagCondition" />
            <label for="hasFlagCondition">Flag Question?:</label>
          </div>
          <div *ngIf="question.hasFlagCondition && isMultipleChoiceQuestion()" class="form-group">
            <label for="flag">Flag if answer is:</label>
            <select id="flagDirection"  class="browser-default form-control"
            name="flagDirection" name="flagDirection" [(ngModel)]="flagDirection" [compareWith]="compareIds">
              <option *ngFor="let dir of FlagDirections;" [ngValue]="dir">{{dir.name}}</option>
            </select>
            <select class="form-control browser-default" id="flagValue" name="flagValue" name="flagValue" [(ngModel)]="flagValue" [compareWith]="compareIds">
              <option *ngFor="let label of  getAnswerLabels();" [ngValue]="label">{{label.label}}</option>
            </select>
          </div>
          <div *ngIf="question.hasFlagCondition && isChecklistQuestion()" class="form-group">
            <label for="flag">Flag if answer is:</label>
            <ul>
              <li *ngFor="let label of getAnswerLabels();">
                <label for="condition-{{label.id}}">{{label.label}}</label>
                <input id="condition-{{label.id}}" type="checkbox" class="form-control" (click)="toggleChecklistFlagValue(label)" [checked]="hasFlagValue(label)" /></li>
            </ul>
          </div>
          <div class="form-group">
            <label for="scale">Scale</label>
            <select id="scale" class="browser-default form-control" name="scale" *ngIf="scales?.length > 1" [(ngModel)]="question.assessment_scale">
              <option *ngFor="let scale of scales" [ngValue]="scale">{{scale.name}}</option>
            </select>
            <input class="form-control" readonly *ngIf="scales?.length == 1" [value]="scales[0].name">
          </div>
        </form>
        <input type="button" [disabled]="isSaving" (click)="save()" class="btn btn-primary" value="Save" />
        <input type="button" [disabled]="isSaving" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New"
        />
        <!--<pre>
      {{ctrl.question|json}}
    </pre>-->
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/question-edit/question-edit.component.html